module.exports = __webpack_public_path__ + "img/hr-sand-decal-22.25fb8163.png";